import React, {FC} from 'react';

import {DropdownItemAvatar} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownItemAvatar';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {VisualContactModel} from '../../../models/api/visualContactModel';
import {ContactAvatar} from '../avatars/contactAvatar';
import {DropdownItemTeammateAvatarWithStatus} from './dropdownItemTeammateAvatarWithStatus';

/*
 * Props.
 */

export interface DropdownItemContactAvatarProps {
  contact: VisualContactModel;
}

/*
 * Component.
 */

export const DropdownItemContactAvatar: FC<DropdownItemContactAvatarProps> = ({contact}) => {
  if (contact.teammate && contact.onlineStatus) {
    return (
      <DropdownItemTeammateAvatarWithStatus teammate={contact.teammate} onlineStatus={contact.onlineStatus} />
    );
  }
  return (
    <DropdownItemAvatar>
      <ContactAvatar visualContact={contact} size={VisualSizesEnum.MEDIUM} />
    </DropdownItemAvatar>
  );
};
